import styled from 'styled-components';
import Theme from '../../theme';

export const QuoteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 80%;
  justify-content: center;
  line-height: 2rem;
  @media screen and (min-width: 840px) {
    > * {
      margin-right: ${Theme.space[2]}px;
    }
  }
`;

export const QuoteText = styled.div`
  text-align: center;
  font-style: italic;
  font-size: ${Theme.fontSizes[6]}px;
  font-family: ${Theme.fonts.body};
`;

export const QuoteAuthor = styled.span`
  text-align: center;
  color: ${Theme.colours.blue};
  font-family: ${Theme.fonts.heading};
  font-size: ${Theme.fontSizes[0]}px;
  line-height: ${Theme.lineHeights.body}px;
  letter-spacing: 0.1rem;
  font-weight: bold;
`;
